/* Pureverr site chrome behaviour. Two small jobs, both additive: the cart badge acknowledges a change
   of count, and the product media deck warms the slide the visitor is most likely to ask for next.
   Nothing here drives layout, and nothing here is required for the page to work. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     1 - cart count. Shopify re-renders #cart-icon-bubble from the
     cart-icon-bubble section on every cart change, so the badge is a
     NEW element each time; watch the link's subtree rather than the
     badge, and only react when the number actually changed.
     --------------------------------------------------------------- */
  var link = document.getElementById('cart-icon-bubble');
  if (link && window.MutationObserver) {
    var read = function () {
      var b = link.querySelector('.cart-count-bubble span');
      return b ? b.textContent.trim() : null;
    };
    var last = read();
    new MutationObserver(function () {
      var now = read();
      if (now === null || now === last) return;
      last = now;
      var bubble = link.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('pv-cart-count--bump');
      /* one frame of nothing, so the class re-application actually restarts the transition */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bubble.classList.add('pv-cart-count--bump');
          setTimeout(function () { bubble.classList.remove('pv-cart-count--bump'); }, 170);
        });
      });
    }).observe(link, { childList: true, subtree: true, characterData: true });
  }

  /* ---------------------------------------------------------------
     2 - the navigation drawer's aria-expanded
     The base theme sets aria-expanded when the summary is CLICKED, so
     closing with Escape leaves it reading "true" on a closed drawer -
     measured: details.open false, aria-expanded "true". The <details>
     element's own open state is the truth, so mirror that instead of
     trying to catch every way it can be closed.
     --------------------------------------------------------------- */
  var det = document.getElementById('Details-menu-drawer-container');
  if (det && window.MutationObserver) {
    var sum = det.querySelector('summary');
    var mirror = function () {
      if (sum) sum.setAttribute('aria-expanded', det.open ? 'true' : 'false');
    };
    mirror();
    new MutationObserver(mirror).observe(det, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---------------------------------------------------------------
     3 - product media deck
     --------------------------------------------------------------- */
  var list = document.querySelector('media-gallery .product__media-list');
  if (!list) return;
  var slides = Array.prototype.slice.call(list.children);
  if (slides.length < 2) return;

  /* current slide semantics. The base theme marks the active dot with a class and nothing else;
     mirror it onto aria-current so the control says which image is showing, not just which dot is
     darker. The dots are re-marked by the theme's own slider code, so watch rather than compute. */
  var dots = document.querySelectorAll('media-gallery .slider-buttons .slider-counter__link');
  if (dots.length && window.MutationObserver) {
    var sync = function () {
      Array.prototype.forEach.call(dots, function (d) {
        if (d.classList.contains('slider-counter__link--active')) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    };
    sync();
    var mo = new MutationObserver(sync);
    Array.prototype.forEach.call(dots, function (d) {
      mo.observe(d, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* adjacent-slide preparation. NOT a preload of all eight: one neighbour at a time, at LOW fetch
     priority, only after the page has loaded and only when the browser is idle - so it can never
     compete with the first slide, which is the LCP candidate. Skipped entirely on Save-Data and on
     2g, where spending a megabyte on a swipe that may not happen is the wrong trade. */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var warmed = [];
  function warm(i) {
    if (i < 0 || i >= slides.length || warmed[i]) return;
    warmed[i] = true;
    var img = slides[i].querySelector('img');
    if (!img || img.complete) return;
    if ('fetchPriority' in img) img.fetchPriority = 'low';
    else img.setAttribute('fetchpriority', 'low');
    img.loading = 'eager';
  }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 240); };
  function after(fn) {
    if (document.readyState === 'complete') idle(fn, { timeout: 2000 });
    else window.addEventListener('load', function () { idle(fn, { timeout: 2000 }); }, { once: true });
  }
  warmed[0] = true;
  after(function () { warm(1); });

  /* and on every change of slide, prepare the next neighbour - again at idle, again one at a time */
  if (!window.IntersectionObserver) return;
  var current = 0;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.intersectionRatio < 0.6) return;
      var i = slides.indexOf(e.target);
      if (i < 0 || i === current) return;
      current = i;
      idle(function () { warm(i + 1); }, { timeout: 2000 });
    });
  }, { root: list, threshold: [0.6] });
  slides.forEach(function (s) { io.observe(s); });
})();

/* 2026-09-18 final UI pass, corrective: the cart's shipping-benefit sheen (assets/pureverr-cart.css `pv-cart-ship-sheen`) runs once
   per page view. The drawer's markup is replaced on every cart change, so CSS alone would replay it; the first `animationend`
   sets a flag on <html> and the stylesheet switches the animation off from then on. No cart code is involved. */
(function () {
  if (window.__pvSheenOnce) return;
  window.__pvSheenOnce = true;
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'pv-cart-ship-sheen') document.documentElement.setAttribute('data-pv-sheen-done', '');
  });
})();
